<template>
  <p>
    VIZBI 2021 was the 11<sup>th</sup> international meeting on Visualizing Biological Data. It was
    held as an <a href="https://www.embl.de/">EMBL</a> virtual conference, from March 24&ndash;26.
    The conference featured talks from 21 world-leading researchers showcasing visualizations
    transforming how life scientists view data, and driving key advances in molecular biology,
    systems biology, biomedical science, and ecology.
  </p>
  <HeroImage
    hero-image="Hero.jpg"
    flyer-low-res="Poster.jpg"
    flyer-hi-res="Poster.pdf"
    assets="Assets.zip"
    credit="EMBL 2021 | Aleksandra Krolik" />
  <p>
    The conference bought together a diverse community, including bioinformaticians, data
    scientists, computer scientists, and experimentalists, as well as medical illustrators, graphic
    designers, and graphic artists. All participants had the opportunity to present a
    <a href="Posters">poster and lightning talk</a> describing their work.
  </p>

  <p>
    As with previous meetings, VIZBI 2021 was an exciting event that will again helped raise the
    standard of data visualization in the life sciences. We hope very much you can join us!
  </p>

  <p>
    To receive updates about VIZBI, you can join the
    <a href="/blog/vizbi-mailing-list/">VIZBI mailing list</a>.
  </p>

  <h4 style="margin-top: 12px; margin-bottom: 0px">Key Dates</h4>
  <!-- <p style="margin-bottom: 0px; margin-top: 6px;"><b>February 1, 23:00 CET:</b> Extended deadline for <a href="Registration#CPP">EMBL CPP Fellowship</a> applications</p> -->
  <p style="margin-bottom: 0px; margin-top: 0px">
    <del><b>March 1, 23:00 CET:</b> Deadline for online registration<sup>*</sup></del>
  </p>
  <p style="margin-bottom: 0px; margin-top: 6px">
    <del>
      <b>March 15, 23:00 CET:</b> Extended deadline for Poster, Lightning Talk, and Art &amp;
      Biology uploads</del
    >
  </p>
  <p>
    <del>
      <sup>*</sup>
      <em>
        After March 1, <a href="Contact">contact us by email</a> to ask about late registration.</em
      ></del
    >
  </p>
</template>

<script setup>
import HeroImage from "@/components/HeroImage.vue";
</script>
